<template>
    <div class="addCompaniesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>
        <div v-else class="row">
            <div class="formulario col-sm-6 col-md-10">
                <v-form ref="form" lazy-validation class="mt-5 col-sm-10 col-md-6">

                    <v-text-field color="secondary" :label="'*'+$t('bonus.label.commerce.title')" :placeholder="$t('bonus.label.commerce.text')" 
                        :counter="200" :maxlength="200" required :rules="businessRules"
                        v-model="formData.business"></v-text-field>

                    <v-text-field color=secondary :label="'*'+$t('bonus.label.title.title')" :placeholder="$t('bonus.label.title.text')" 
                        :counter="100" :maxlength="100" required :rules="titleRules"
                        v-model="formData.title"></v-text-field>

                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        color="secondary"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formattedStartDate"
                            :label="'*'+$t('bonus.label.startDate')"
                            color="secondary"
                            :rules="startDateRules"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="localStartDate"
                        color="primary"
                        @change="handleStartDateChange"
                        ></v-date-picker>
                    </v-menu>

                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        color="secondary"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formattedEndDate"
                            :label="'*'+$t('bonus.label.endDate')"
                            color="secondary"
                            :rules="endDateRules"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="localEndDate"
                        color="primary"
                        @change="handleEndDateChange"
                        ></v-date-picker>
                    </v-menu>

                    <v-textarea outlined color="secondary" :label="'*'+$t('bonus.label.termsConditions.title')" :placeholder="$t('bonus.label.termsConditions.text')" 
                        :counter="1000" :maxlength="1000" required :rules="termsAndConditionsRules"
                        v-model="formData.termsAndConditions" class="mt-5"></v-textarea>
                </v-form>

                <div class="image-container col-sm-10 col-md-4">
                    <span>{{ $t('bonus.label.imageCommerce.title') }}</span>
                    <changeImage :image="this.businessImageFile" />
                    <div class="img-btn">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="business-file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>{{ $t('label.image.text') }}</span>
                        </v-tooltip>
                        <input type="file" @change="onFileBusiness" id="business-file-input" accept="image/*" style="display: none" />                        
                    </div>
                    <br>
                    <br>
                    <span>{{ $t('bonus.label.imageBonus.title') }}</span>
                    <div>
                        <changeImage :image="this.bondImageFile" />
                    </div>
                    <div class="img-btn">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="bond-file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>{{ $t('label.image.text') }}</span>
                        </v-tooltip>
                        <input type="file" @change="onFileBond" id="bond-file-input" accept="image/*" style="display: none" />                        
                    </div>
                    <br>
                    <br>
                    <span>{{ $t('bonus.label.imageCodeBonus.title') }}</span>
                    <div>
                        <changeImage :image="this.codeImageFile" />
                    </div>
                    <div class="img-btn">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="code-file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>{{ $t('label.image.text') }}</span>
                        </v-tooltip>
                        <input type="file" @change="onFileCode" id="code-file-input" accept="image/*" style="display: none" />                        
                    </div>
                </div>    

            </div>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">

                    <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on"
                        @click="submitForm">
                        <v-icon dark>mdi-content-save</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('button.save') }}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import changeImage from "@/shared/components/change_image/change_image_component.vue";
import i18n from '@/plugins/i18n';

import {
  BONUS_M,
  GET_STATE_LOADING,
  ACTION_POST_CREATE_BONUS,
} from "@/views/bonus/store/types/types.js";

import Swal from "sweetalert2";
export default {

    components: {
        changeImage,
    },
    name: "addBonusComponent",

    data() {
        return {
            formData: {
                title: null,
                business: null,
                startDate: null,
                endDate: null,
                termsAndConditions: null,
                businessImage: null,
                bondImage: null,
                codeImage: null,
            },
            menu1: false, // Para el date picker de fecha inicio
            menu2: false, // Para el date picker de fecha fin
            localStartDate: null,
            localEndDate: null,
            formattedStartDate: '',
            formattedEndDate: '',
            businessImageFile: null, // Estado local para almacenar la URL de la imagen seleccionada
            bondImageFile: null,
            codeImageFile: null,
            allowedImageTypes: [
                "image/jpeg",
                "image/png",
                "image/jpg",
                "image/svg+xml",
            ],

            businessRules: [
                v => !!v || this.$t('bonus.label.commerce.required'),
            ],
            titleRules: [
                v => !!v || this.$t('bonus.label.title.required'),
            ],
            startDateRules: [
                v => !!v || this.$t('bonus.label.startDate.required'),
            ],
            endDateRules: [
                v => !!v || this.$t('bonus.label.endDate.required'),
            ],
            termsAndConditionsRules: [
                v => !!v || this.$t('bonus.label.termsConditions.required'),
            ],
            showErrorMessages: false,
        };
    },

    mounted() {
        // Escuchar evento para limpiar el formulario cuando el diálogo se cierra
        EventBus.$on('clear-bonus-form', this.clearForm);
    },
    beforeDestroy() {
        // Limpiar el event listener
        EventBus.$off('clear-bonus-form', this.clearForm);
    },

    computed: {
        ...mapGetters({
            loading: [`${BONUS_M}${GET_STATE_LOADING}`],
        }),
    },

    methods: {
        ...mapActions({
            postActionCreateBonus: `${BONUS_M}${ACTION_POST_CREATE_BONUS}`,
        }),
        handleStartDateChange(date) {
            const selectedDate = new Date(`${date}T00:00:00`);
            if (isNaN(selectedDate)) {
                console.error("Invalid date object:", date);
                return;
            }
            
            this.localStartDate = date;
            const modifiedDate = new Date(selectedDate);
            this.formData.startDate = date;
            this.formattedStartDate = date;
            this.validateStartDate(modifiedDate);
            this.menu1 = false;
        },

        validateStartDate(modifiedDate) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const selectedDate = new Date(modifiedDate);
            if (selectedDate < today) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.date.invalid'),
                    text: i18n.t('label.startDate.invalid.text1'),
                });
                this.localStartDate = null;
                this.formattedStartDate = "";
                this.formData.startDate = null;
                return;
            }
            
            const anioActual = new Date().getFullYear();
            const anioSeleccionado = modifiedDate.getFullYear();
            if (anioSeleccionado > anioActual) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.date.invalid'),
                    text: i18n.t('label.startDate.invalid.text2')
                });
                this.localStartDate = null;
                this.formattedStartDate = "";
                this.formData.startDate = null;
                return;
            }

            if(this.formData.endDate != null){
                if (this.formData.startDate > this.formData.endDate) {
                    Swal.fire({
                        icon: "error",
                        title: i18n.t('label.date.invalid'),
                        text: i18n.t('label.startDate.invalid.text3'),
                    });
                    this.localStartDate = null;
                    this.formattedStartDate = "";
                    this.formData.startDate = null;
                    return;
                }
            }
        },

        handleEndDateChange(date) {
            const selectedDate = new Date(`${date}T00:00:00`);
            if (isNaN(selectedDate)) {
                console.error("Invalid date object:", date);
                return;
            }
            this.localEndDate = date;
            const modifiedDate = new Date(selectedDate);
            this.formData.endDate = date;
            this.formattedEndDate = date;
            this.validateEndDate(this.localEndDate, modifiedDate);
            this.menu2 = false;
        },

        validateEndDate(localEndDate, modifiedDate) {
            if (localEndDate < this.localStartDate) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.date.invalid'),
                    text: i18n.t('label.endDate.invalid.text1'),
                });
                this.localEndDate = null;
                this.formattedEndDate = "";
                this.formData.endDate = null;
                return;
            }
            const anioActual = new Date().getFullYear();
            const anioSeleccionado = modifiedDate.getFullYear();
            if (anioSeleccionado > anioActual) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.date.invalid'),
                    text: i18n.t('label.endDate.invalid.text2'),
                });
                this.localEndDate = null;
                this.formattedEndDate = "";
                this.formData.endDate = null;
                return;
            }
        },

        // Método para manejar el cambio de imagen del comercio
        onFileBusiness(event) {
            const file = event.target.files[0];
            if (file) {
                // Asignar el archivo de imagen seleccionado a formData.imageFile
                this.formData.businessImage = file;

                // Leer la URL de la imagen seleccionada y actualizar imageFile si es necesario
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.businessImageFile = e.target.result; // Actualizar la URL de la imagen seleccionada
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.businessImage.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.invalid.title'),
                    text: i18n.t('label.image.invalid'),
                });
            }
        },

        // Método para manejar el cambio de imagen del bono
        onFileBond(event) {
            const file = event.target.files[0];
            if (file) {
                // Asignar el archivo de imagen seleccionado a formData.imageFile
                this.formData.bondImage = file;

                // Leer la URL de la imagen seleccionada y actualizar imageFile si es necesario
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.bondImageFile = e.target.result; // Actualizar la URL de la imagen seleccionada
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.bondImage.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.invalid.title'),
                    text: i18n.t('label.image.invalid'),
                });
            }
        },

        // Método para manejar el cambio de imagen del código del bono
        onFileCode(event) {
            const file = event.target.files[0];
            if (file) {
                // Asignar el archivo de imagen seleccionado a formData.imageFile
                this.formData.codeImage = file;

                // Leer la URL de la imagen seleccionada y actualizar imageFile si es necesario
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.codeImageFile = e.target.result; // Actualizar la URL de la imagen seleccionada
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.codeImage.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.invalid.title'),
                    text: i18n.t('label.image.invalid'),
                });
            }
        },

        async submitForm() {
            try {

                const result = await Swal.fire({
                    title: i18n.t('label.confirm.title'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: i18n.t('button.save.text'),
                    cancelButtonText: i18n.t('button.cancel.text'),
                    confirmButtonColor: '#6E17A5'
                });
                if (result.isConfirmed) {
                    // Validar el formulario antes de enviarlo
                    const validationErrors = this.validateForm();

                    // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.errorsValidation.plural.title'),
                            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }
                    // Si no hay errores de validación, imprime el formulario en la consola
                    const save = await this.postActionCreateBonus(this.formData);
                    if (!save) {
                        return Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.invalid.title'),
                            text: i18n.t('label.invalid.text')
                        })
                    }
                    await this.clearForm();
                    EventBus.$emit('formBonus-submitted-successfully');
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: i18n.t('label.delete.cancel'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            } catch (error) {
                console.error(i18n.t('label.failService'));
            }
        },

        validateForm() {
            this.showErrorMessages = true;
            const errors = {};

            if (!this.formData.business || !this.formData.business.trim() || this.formData.business.length > 200) {
                errors.business = this.$t('bonus.label.commerce.title');
            }

            if (!this.formData.title || !this.formData.title.trim() || this.formData.title.length > 100) {
                errors.title = this.$t('bonus.label.title.title');
            }

            if (!this.formData.startDate) {
                errors.startDate = this.$t('bonus.label.startDate');
            }

            if (!this.formData.endDate) {
                errors.endDate = this.$t('bonus.label.endDate');
            }

            if (!this.formData.termsAndConditions || !this.formData.termsAndConditions.trim() || this.formData.termsAndConditions.length > 1000) {
                errors.termsAndConditions = this.$t('bonus.label.termsConditions.title');
            }

            if (!this.formData.businessImage) {
                errors.businessImage = this.$t('bonus.label.imageCommerce.title');
            }

            if (!this.formData.bondImage) {
                errors.bondImage = this.$t('bonus.label.imageBonus.title');
            }

            if (!this.formData.codeImage) {
                errors.codeImage = this.$t('bonus.label.imageCodeBonus.title');
            }

            return errors;
        },

        clearForm() {
            // Resetear formData
            this.formData = {
                title: null,
                business: null,
                startDate: null,
                endDate: null,
                termsAndConditions: null,
                businessImage: null,
                bondImage: null,
                codeImage: null,
            };
            
            // Resetear variables locales
            this.menu1 = false;
            this.menu2 = false;
            this.localStartDate = null;
            this.localEndDate = null;
            this.formattedStartDate = '';
            this.formattedEndDate = '';
            this.businessImageFile = null;
            this.bondImageFile = null;
            this.codeImageFile = null;
            
            // Resetear validación del formulario
            if (this.$refs.form) {
                this.$refs.form.reset();
            }
            
            // Resetear inputs de archivo
            const bondInput = document.querySelectorAll('input[type="file"][accept*="image"]');
            if (bondInput.length > 1) {
                bondInput.forEach(input => input.value = '');
            }
        },
    },
};

</script>


<style lang="css" scoped>
/* Css input imagen*/

.formulario {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5vw;
}

.row {
    display: flex;
    justify-content: center;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.img-btn {
    margin-top: 20px;
}

/*Resposive*/

@media screen and (max-width: 425px) {
    .formulario {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }
}


/* Para pantallas muy pequeñas */
@media screen and (max-width: 425px) {
    .formulario{
        flex-direction: column;
        align-items: center;
    }

    .image-container {
        margin-bottom: 20px;
    }
}
</style>